module.exports = __webpack_public_path__ + "dress.jpg?5e08c80b793cf36d13136f861da505a0";